import './libraries/lazysizes';
import './libraries/fileService';
import './libraries/tl-timepicker';
import './controllers/cart';
import './controllers/charts';
import './controllers/favorites';
import './controllers/products';
import './controllers/print';
import './controllers/share';
import './controllers/tabs';
import './controllers/options';
import './controllers/notification';
import './controllers/contrast';
import './controllers/page-readspeaker';
import './controllers/form-datepicker';
import './controllers/form-dependencies-client';
import './controllers/form-validation';
import './controllers/form-datetime';
import './controllers/form';
import './controllers/intranetApp';
import './controllers/intranet';
import { layoutManager } from './controllers/layout';
import { accordionManager } from './controllers/accordion';
import { dropdownManager } from './controllers/dropdown';
import { gridMenuManager } from './controllers/grid-menu';
import { mainMenuManager } from './controllers/main-menu';
import { personalMenuManager } from './controllers/personal-menu';
import { timelineManager } from './controllers/timeline';
import { clusterManager } from './controllers/cluster';
import { formuleFormManager } from './controllers/formule-form';
import { countdownManager } from './controllers/countdown';
import { formulaVisualManager } from './controllers/formula-visual';
import { timetableManager } from './controllers/timetable';
import { accessibilityManager } from './controllers/accessibility';
export default async () => {
    dropdownManager.init('.js-Selectize');
    accordionManager.init();
    personalMenuManager.init($('.Personal'), $('.Personal_MenuList'), $('.Personal_Blocks'));
    mainMenuManager.init($('.MainNav'), $('.Subnavigation_Wrapper'));
    timelineManager.init();
    gridMenuManager.init();
    clusterManager.init();
    formuleFormManager.init();
    countdownManager.init();
    formulaVisualManager.init();
    timetableManager.init();
    accessibilityManager.init(layoutManager.webPage, $('.MobNav').add(layoutManager.personalPage.add(layoutManager.menu)));
    await import('./controllers/habitat');
};
